import * as React from 'react';
import { FC } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import styles from './assets/infoCard.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
    value: number | string;
    link: string;
    label: number | string;
    icon: IconDefinition;
    k: string;
}

const InfoCard: FC<Props> = ({ value, label, link, icon, k }: Props) => {
    return (
        <Card className={classNames(styles.card)}>
            <Link className={' '} to={link}>
                <Card.Body className={classNames(styles.cardBody, 'd-flex  align-items-center')}>
                    <div className={classNames(styles.leftPart, ' d-flex flex-column  align-items-start ')}>
                        <Card.Title className={classNames(styles.value)}>
                            <span>{value}</span>
                        </Card.Title>
                        <Card.Text className={classNames(styles.Text)}>{label}</Card.Text>
                    </div>
                    <div
                        className={classNames(
                            styles.infoIcon,
                            k + '  d-flex justify-content-center align-items-center',
                        )}
                    >
                        <FontAwesomeIcon className={classNames(styles.icon)} icon={icon} />
                    </div>
                </Card.Body>
            </Link>
        </Card>
    );
};
/* a{
     min-width: auto;
     width: 130px;
     min-height: 100px;
      > div {
        padding: 0.25rem;
      }
   }
   p{
     font-size: 14px;
   }
 }*/
export default InfoCard;
